import { gql } from '@apollo/client'
import { pathOr } from 'ramda'
import { useSessionPermission } from '@btime/react-session'
import React from 'react'

import { placesClient } from '../../../utils/apollo/api'
import { usePromiseQuery } from '../../../utils/apollo/_helpers/promiseQuery'
import Select from '../../../packages/kiti/components/form/Select'
import { capitalize } from '@btime/helpers'
import { useSavePlaceLevel } from './_requests/savePlaceLevel'

const QUERY = gql`
  query PlaceLevels($page: Int, $search: String, $filter: PlaceLevelFilter) {
    placeLevels(page: $page, search: $search, filter: $filter, sort: { field: NAME, type: ASC }) {
      id
      name
      levelId
      parentId
      type
      resume
      level {
        id
        name
      }
    }
  }
`

const usePlaceLevelsLoader = () => {
  const query = usePromiseQuery(QUERY, { client: placesClient })

  return (search, page = 1) => {
    return query({ search, page })?.then(pathOr([], ['data', 'placeLevels']))
  }
}

const PlaceLevelsSelectV2 = ({
  onChange,
  value,
  canCreate,
  assign,
  parentId,
  type,
  levelId,
  multiple = false,
  ...props
}) => {
  const createPlaceLevel = useSessionPermission(`create${capitalize(type)}sPlaceLevel`)
  const getOptions = usePlaceLevelsLoader()
  const onSuccess = result => onChange(result.id, result.name, result)
  const [onCreate, { loading }] = useSavePlaceLevel(onSuccess, { parentId, levelId, type })
  return (
    <Select
      value={value} //
      onChange={onChange}
      options={getOptions}
      onCreate={canCreate && createPlaceLevel && onCreate}
      multiple={multiple}
      assign={assign}
      {...props}
    />
  )
}

export default PlaceLevelsSelectV2
